import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import Faq from "./Faq";

function FaqSection(props) {
  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={3}
          spaced={true}
          className="has-text-centered"
        ></SectionHeader>
        <Faq
          items={[
            {
              question: "What do I have to do?",
              answer:
                "You need to be able to follow Covid-19 on a daily to weekly basis, following the local news in your community and updating our database via a google sheet you will be given access to."
            },
            {
              question: "Do I need any qualifications?",
              answer:
                "Nope. You just need to be a concerned and trustworthy citizen looking to help fight misinformation and help the cause."
            },
            {
              question: "What happens after I fill out the form?",
              answer:
                "After you fill out the form, you will be invited into our slack channel where someone from our team will reach out to verify your identity and bring you through the next steps."
            },
            {
              question: "Who are you?",
              answer:
                "We are a group of passionate builders who want to help do our part in this time of crisis. We come from all walks of life"
            }
          ]}
        ></Faq>
      </div>
    </Section>
  );
}

export default FaqSection;
